export const SCREEN_NAMES = {
    COMPONENT_EDITOR: 'Component Editor',
    PAGE_EDITOR: 'Page Editor',
    TEMPLATE_EDITOR: 'Template Editor',
    SETTINGS: 'Settings',
};
